import { render, staticRenderFns } from "./AttendanceReasonChart.vue?vue&type=template&id=06c69c48&scoped=true"
import script from "./AttendanceReasonChart.vue?vue&type=script&lang=js"
export * from "./AttendanceReasonChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c69c48",
  null
  
)

export default component.exports